<template>

  <div>
    <Loader cover v-if="local.isProcessing"/>

    <div class="vx-row">
      <div class="vx-col w-full mb-4">
        <LiveClassScheduleInfoInfo/>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <VdoLiveSetTopicEdit/>
      </div>
    </div>

    <!----------------------------------------- Actions Button ---------------------------------------------------->
    <div class="vx-row pt-2">
      <div class="vx-col w-full">
        <vs-button :disabled="isUploading" @click.prevent="onBackClick"
                   color="success"
                   type="border">
          {{ $t('general.back') }}
        </vs-button>
      </div>
    </div>

  </div>

</template>

<script>
  import {state} from './data';

  import VdoLiveSet from '@/store/modules/live-class/vdo-live-set/index';
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";

  if (!state.store.VdoLiveSet) state.registerModule(`VdoLiveSet`, VdoLiveSet);

  const {
    mapActions: mapVdoLiveSetActions,
  } = createNamespacedHelpers(`VdoLiveSet`);


  const {
    mapFields: mapVdoLiveSetFields,
  } = createHelpers({
    getterType: `VdoLiveSet/getField`,
    mutationType: `VdoLiveSet/updateField`,
  });

  export default {
    props: {
      vdoLiveSetId: {
        type: String,
        require: true,
      }
    },
    components: {
      Loader: () => import('@/components/common-ui/loader-block/index.vue'),
      LiveClassScheduleInfoInfo: () => import('./SubComponents/LiveClassScheduleInfoInfo'),
      VdoLiveSetTopicEdit: () => import('./SubComponents/VdoLiveSetTopicEdit'),
    },
    computed: {
      ...mapVdoLiveSetFields({
        vdoLiveSetProcessing: 'processing',
      }),
      isUploading() {
        return this.local.isUploading;
      },
    },
    watch: {
      vdoLiveSetProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    data() {
      return {
        store: state.store,
        local: state.local,

        vdoLiveSetEdit: state.local.vdoLiveSetEdit,
        vdoLiveSetTopicEdit: state.local.vdoLiveSetTopicEdit,

      }
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapVdoLiveSetActions({
        getVdoLiveSetByLiveClassScheduleId: 'getVdoLiveSetByLiveClassScheduleId',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onBackClick() {
        this.$router.push(
          {
            name: "vdo-live-set",
          }
        );
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      async loadData() {

        if (this.$route.params.liveClassScheduleId) {
          let result = await this.getVdoLiveSetByLiveClassScheduleId({liveClassScheduleId: this.$route.params.liveClassScheduleId})
          if (result) {
            this.vdoLiveSetEdit.vdoLiveSet = JSON.parse(JSON.stringify(result));
            this.vdoLiveSetTopicEdit.vdoLiveSetTopics = this.vdoLiveSetEdit.vdoLiveSet.vdoLiveSetTopics;
          }
        }

      },

    },
    async created() {
      await this.loadData();
    },
  }
</script>

<style scoped>

</style>
